<ng-container screenAnalytics="task-view">
    <div class="modal-header no-icon">
        <h3 class="modal-title">{{ isEditing ? 'Edit' : 'View' }} Task</h3>
        <enhanced-help-switch></enhanced-help-switch>
        <button
            type="button"
            aria-label="Close"
            class="close"
            (click)="onCancel()"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <general-task-details
        *ngIf="!isEditing"
        [generalTaskId]="taskId"
        (edit)="toggleViewEdit()"
        (deleted)="onTaskDeleted()"
    >
    </general-task-details>
    <general-task-edit
        #editTaskDialogue
        *ngIf="isEditing"
        [generalTaskId]="taskId"
        (editingCancelled)="toggleViewEdit()"
        (taskUpdated)="taskUpdated($event)"
    >
    </general-task-edit>
</ng-container>
